import React, {} from 'react'
import styles from './home.module.scss'
import classNames from 'classnames';
import cartoomArt from './img/cartom-blobb.png'
import icon_Linkedin from './img/icons8-linkedin.svg'
import icon_GitHub from './img/icons8-github.svg'
import icon_Whatsapp from './img/icons8-whatsapp.svg'
import ReactTyped from 'react-typed'
import { Link } from 'react-scroll';

export default function HomePtBr({darkMode}) {
    const DarkModeTextColorPrimary = darkMode ? '#FFFFFF' : '#4d4d4d';
    const DarkModeTextColorSecondary = darkMode ? 'rgb(226, 226, 226)' : '#4d4d4d';
    
    return (
        <>
        <section className={styles.container} id="home">
        
            <div className={classNames(styles.container_division, 'scroll_scale')}>
                <div className={styles.introduction}>
                    <p style={{color: DarkModeTextColorSecondary}} className={styles.introduction_welcome}>Olá Mundo !</p>
                    <h1 style={{color: DarkModeTextColorPrimary}} className={styles.introduction_name}>Eu sou{' '}
                        <ReactTyped
                        strings={['Marcos Maio','Desenvolvedor Web']}
                        typeSpeed={100}
                        backSpeed={90}
                        backDelay={2000}
                        style={{color: DarkModeTextColorPrimary, fontWeight: 700}}
                        loop
                        >
                        <span></span>
                        </ReactTyped>
                    </h1>
                    <p style={{color: DarkModeTextColorSecondary}} className={styles.introduction_welcome}>Bem-vindo ao site do meu portfólio</p>
                </div>
                <div className={styles.wrap}>
                    <Link 
                        to='about' 
                        smooth={true} 
                        duration={500}
                        offset={-100}
                        spy={true}
                    >
                        <button className={`${styles.button} ${darkMode ? styles.buttonDarkMode : ''}`}>
                            Mais sobre mim        
                        </button>
                    </Link>
                </div>
                
                <div className={styles.redes_sociais}>
                    <a href='https://www.linkedin.com/in/marcos-maio-792aab23a/' target="_blank" rel="noreferrer"> 
                        <img src={icon_Linkedin} alt=""  className={styles.redes_sociais_icon}/>
                    </a>
                    <a href='https://github.com/MarcosMaio' target="_blank" rel="noreferrer"> 
                        <img src={icon_GitHub} alt="Icone "  className={styles.redes_sociais_icon}/>
                    </a>
                    <a href='https://api.whatsapp.com/send?phone=5521965399177' target="_blank" rel="noreferrer"> 
                        <img src={icon_Whatsapp} alt=""  className={styles.redes_sociais_icon}/>
                    </a>
                </div> 
                
            </div>
                <div className={classNames(styles.container_art, 'scroll_scale')}>
                    <img src={cartoomArt}  alt="" />
                </div>
            
            
        </section>
            
        </>
    );
}
